module.exports = __webpack_public_path__ + "static/appointer-calendar-019bf4ef536f2e7076092d5e469a0d0c.png";